<template>
<div class="headerContainer" style="">
    <footer style="background:#030408;opacity:0.8">
        <div class="footer">
        <img v-animate-onscroll="'animate__animated animate__fadeInRight'" src="@/assets/images/logoFooter.png" alt="" srcset="" style="width:275px;float:right">
        <div class="clearBoth"></div>
    <div class="content" style="margin:20px auto ">
        <div class="mid"  v-animate-onscroll="'animate__animated animate__fadeInLeft'">
            <div class="fcon">
            <div class="tit">青岛优力美色彩科技有限公司</div>
        </div>
            <div class="fnav">
                <ul>
                    <li>
                        <span>地址：</span>
                        <span>{{configObj.address.value}}</span>
                    </li>
                    <li>
                        <span>传真：</span>
                        <span>{{configObj.fax.value}}</span>
                    </li>
                    <li>
                        <span>电话：</span>
                        <span>{{configObj.mobile.value}}</span>
                    </li>
                    <li>
                        <span>手机：</span>
                        <span>{{configObj.tel.value}}</span>
                    </li>
                    <li>
                        <span>地址：</span>
                        <span>{{configObj.address.value}}</span>
                    </li>
                    <li>
                        <span>生产地址：</span>
                        <span>{{configObj.address1.value}}</span>
                    </li>
                    <li>
                        <span>邮箱：</span>
                        <span>{{configObj.email.value}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="clearBoth"></div> -->
        <div class="ewm">
            <div class="inmess">
            <div class="content">
                <form>
                    <div class="inputStyle">
                        <input type="text" class="text1" value="" name="" v-model="saveForm.name" placeholder="姓名">
                    </div>
                   <div class="inputStyle">
                        <input type="text" class="text1" value="" name="" v-model="saveForm.email" placeholder="邮箱">
                    </div>
                    <div class="inputStyle">
                         <input type="text" class="text1" value="" name="" v-model="saveForm.phone" placeholder="电话">
                    </div>
                   
                    <div class="clean"></div>
                    <div class="inputStyle">
                        <textarea class="textarea" placeholder="内容" v-model="saveForm.content"></textarea>
                    </div>
                    <div class="ann">
                        <!-- <input type="button" class="sub" value="提交留言" @click="saveFormEvent"> -->
                        <div style="color:#fff;letter-spacing:1px;cursor:pointer" @click="saveFormEvent">提交留言</div>
                    </div>
                </form>
            </div>
            </div>
        </div>
        <div class="clearBoth"></div>
    </div>
     </div>
    </footer>
    <div class="banq">
        <div class="content">
            <span>页面版权所有©青岛优力美色彩科技有限公司 | Copyright - 2023 All Rights Reserved. 网站建设：青岛观形品牌设计有限公司</span>
            <span>《中华人民共和国电信与信息服务业务经营许可证》 <a href="https://beian.miit.gov.cn" style="cursor:pointer;color:#fff">鲁ICP备17037217号-1</a></span>
        </div>
    </div>
</div>
  
</template>
<script>
import { config,feedback } from '@/api/index.js'
export default {
  name: 'App',
  data() {  
    return {  
        saveForm:{
            name:'',
            email:'',
            content:'',
            phone:''
        },
      configObj:{},
     selected: false,
      menuItems: [  
        // { text: '首页', link: '/' },  
        { text: '首页'},  
        { text: '解决方案'},  
        { text: '新闻资讯'},  
        { text: '关于我们'},  
        { text: '视频中心'},  
        { text: '联系我们' },  
        // 添加更多菜单项...  
      ],  
    };  
  }, 
mounted() {  
    this.config()
},
  methods:{
    saveFormEvent() {
        const self = this
        if(!this.saveForm.content) {
            this.$message('请填写内容');
            return
        }
        feedback(this.saveForm).then((res)=>{
                this.$message({
                    message: '提交成功',
                type: 'success'
                });
                self.saveForm = self.$options.data().saveForm
            })
    },
    config() {
        this.$nextTick(()=>{
            config().then((res)=>{
                this.configObj = res.data
            })
        })
    },
    // 重新加载方法
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(()=>{
        this.isRouterAlive = true;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.headerContainer{
    width:100%;
    // background: #030408;
    // background: url('@/components/footer/images/footer01.png');
      background: #030408 url('./images/footer01.png') no-repeat fixed center/cover padding-box content-box;
    
}
.container{
    width:1460px;
    margin: 0 auto;
    height: 110px;
    line-height: 110px;
}
.clearBoth{
    width:0;height:0;clear:both
}
// .inmess{ padding: 60px 0; background: url(../images/index_07.jpg) repeat-y center; }
.inmess .text1{ margin-bottom: 5px; height: 40px; width: 100%; margin-right: 1%; padding: 0 15px; box-sizing: border-box; background: rgba(0,0,0,.6); color: #fff;border:none}
.inmess .text2{ margin-bottom: 30px; height: 60px; width: 49%; margin-left: 1%; padding: 0 15px; box-sizing: border-box; background: rgba(0,0,0,.6); color: #fff; float: left; border:none}
.inmess .textarea{ width: 100%; height: 80px; padding: 5px 15px; box-sizing: border-box; line-height: 23.333333px; border: 0px; background: rgba(0,0,0,.6); color: #fff; margin-bottom: 0px; }
.inmess .ann{ width: 140px; margin: 20px auto; }
.inmess .ann .sub{ width: 100%; height: 45px; background: #32beff; color: #fff; font-size: 14px; outline: none; }
.inmess .ann .sub:hover{ background: #13394a; }


// background: #030408;
.footer{ padding: 30px 0;  width:1360px;margin:0 auto;}
.footer .fcon{ width: 260px; margin-right: 85px; }
.footer .fcon .tit{ color: #fff; font-size: 20px; font-weight: bold; margin-bottom: 10px; color:#fff}
.footer .fcon .nr{ font-size: 14px; line-height: 25px; color: #999;  }
.footer .mid{ width: 600px; text-align: left; float: left; color:#ddd}
.footer .mid .fnav{ line-height: 40px;  }
.footer .mid .fnav ul li{ display: block; font-size: 14px; font-weight: bold; color: #bebbbb; padding: 0; }
.footer .mid .fnav ul li:hover{ color: #32beff; }
.footer .mid .fenx{ padding: 15px 0; line-height: 40px; }
.footer .mid .fenx span{ display: inline-block; font-size: 14px; color: #999; }
.footer .mid .fenx .li{ display: inline-block; position: relative; width: 40px; height: 30px; text-align: center; line-height: 30px; background: #424343; border-radius: 50%; color: #a1a1a1; font-size: 20px; margin: 0 8px; }
.footer .mid .fenx .li .xf{ position: absolute; width: 100px; height: 100px; background: #fff; left: 50%; margin-left: -50px; top: -120px; display: none; }
.footer .mid .fenx .li:hover .xf{ display: block; }
.footer .mid .fenx .li:hover{ background: #32beff; color: #fff; }
.footer .ewm{ width: 670px; float: right;margin:0 20px 0 0 }
.footer .ewm img{ width: 100%; height: auto; }
.banq{ padding: 10px 0; background: #141415; line-height: 25px; text-align: center; color: #888; font-size: 14px; }
.banq .content{width:1360px;margin: 0 auto;}
.banq span{ display:block;color: #ccc; }
.inputStyle {border-bottom: 1px solid #5c5a5a;}
</style>
